export default {
    donationCategoryParentList: [],
    donationCategoryList: [],
    donationCategoryListCount: 0,
    donationCategoryListForCreate: [],
}